import * as React from 'react';
export const IcRunning = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 9.68a1 1 0 00-1.27-.63l-2 .67a1 1 0 01-.92-.15l-2.89-2.13a3 3 0 00-1.07-.51L9.1 6.25a3 3 0 00-2.39.41L4.45 8.17a1 1 0 101.1 1.66l2.27-1.51a1.06 1.06 0 01.8-.14l2.38.6-3.38 7.63a1 1 0 01-.92.59H4a1 1 0 000 2h2.7a3 3 0 002.74-1.78l1.06-2.38c.056.043.117.08.18.11l1.9.63a1 1 0 01.67.75L14 20.2a1 1 0 001 .8h.2a1 1 0 00.8-1.2l-.77-3.86a3 3 0 00-2-2.26l-1.89-.63 1.4-3.25 1.82 1.37a3 3 0 001.8.6c.323 0 .643-.05.95-.15l2-.67A1 1 0 0020 9.68z'
      fill='currentColor'
    />
  </svg>
);
